import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Components/Form";
import toast from "react-hot-toast";
import Header from "../../../../Components/Header";
import {
  create_home_feature,
  get_home_feature,
  update_home_feature,
} from "../../../../Controllers/Home/Features";
import forms from "../../../../Data/Forms/Home/Features/forms";
import headers from "../../../../Data/Forms/Home/Features/headers";
import Loadercomponent from "../../../../Components/Loader";
import AddButton from "../../../../Components/Buttons/add";
import RemoveButton from "../../../../Components/Buttons/delete";
import { convert_to_file } from "../../../../Controllers/Global";

const HomeFeaturesForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      const feature = id
        ? await update_home_feature({ ...data?.data, id: id })
        : await create_home_feature(data?.data);

      if (feature?.status) {
        if (id) {
          navigate(-1);
        }
        toast?.success(feature?.message);
        setButtonLoader(false);
      } else {
        toast?.error(feature?.message);
        setButtonLoader(false);
      }
    }
  };

  const handleData = async (feature) => {
    let image = feature?.image ? feature?.image : "";
    let file = await convert_to_file(image);
    let title = feature?.title ? feature?.title : "";
    let description = feature?.description ? feature?.description : "";
    let status = feature?.status ? feature?.status : 0;

    forms[0].options[0].form.value = [file];
    forms[0].options[1].form.value = title;
    forms[0].options[2].form.value = description;
    forms[0].options[3].form.value = status;

    setLoader(false);
    setValues([...values]);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const feature = await get_home_feature(data);
      if (feature?.status) {
        handleData(feature?.data);
      } else {
        toast?.error(feature?.message);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header header={headers}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        />
      </Loadercomponent>
    </Header>
  );
};

export default HomeFeaturesForm;
